
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotpassword",
      function () {
        return require("private-next-pages/forgotpassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgotpassword"])
      });
    }
  